export default __webpack_public_path__ + "2c6b9f6723fbd3cf9fb7e9f985110946.jpg";